<template>
  <div id="BaseData">
    <p class="mb-5">
      {{$t('The information entered must match the identification document or it will not be verified.')}}
      <br>
      - {{$t('The time it takes to upload your images varies according to the size of the images and may take some time, please wait until the upload is complete.')}}
      <br>
      - {{$t('If the image quality is poor, it may not be approved and you may re-upload.')}}
    </p>

    <vs-alert color="warning" :title="$t('pending')" active="true" v-if="status=='pending'">
      {{$t('Your information is under review and please wait!')}}
    </vs-alert>
    <vs-alert color="danger" :title="$t('reject')" active="true" v-else-if="status=='reject'">
      {{dataUser.identification['reason_'+islocale]}}
    </vs-alert>
    <vs-alert color="success" :title="$t('confirm')" active="true" v-else-if="status=='confirm'" icon-pack="feather" icon="icon-check">
      {{$t('The information in this section has been successfully verified.')}}
    </vs-alert>

    <MobileVerify @getData="$emit('getData')" :mobileHas="dataUser.mobile"/>

    <form data-vv-scope="BaseData" autocomplete="off" v-if="dataUser.mobile">
      <div class="vx-col md:w-3/5 lg:w-2/5 w-full mt-5 mx-auto">

        <div class="vx-row">
          <!--
          <div class="vx-col w-full my-5 mx-auto lg:flex">
            <vs-button class="w-1/2" :class="iranian?'active':''" type="line" :disabled="(status!='pending' && status!='confirm') || iranian ?false:true" @click="iranian=true">{{$t('Iranian')}}</vs-button>
            <vs-button class="w-1/2" :class="!iranian?'active':''" type="line" :disabled="(status!='pending' && status!='confirm') || !iranian ? false: true" @click="iranian=false">{{$t('Non Iranian')}}</vs-button>
          </div>
          -->

          <div class="vx-col md:w-1/2 w-full mt-5 mx-auto">
            <vs-input :label="$t('Name')" v-model="name" name="name" class="w-full" v-validate="'required|alpha_spaces|min:3|max:50'" :readonly="status=='pending'|| status=='confirm' ? true : false"
                      :success="status=='confirm' ? true : false" :warning="status=='pending' ? true : false"
                      val-icon-success="icon-check" val-icon-warning="icon-clock" val-icon-pack="feather"/>
            <span class="text-danger text-sm" v-show="errors.has('BaseData.name') && this.BaseDataSubmit">{{ errors.first('BaseData.name') }}</span>
          </div>

          <div class="vx-col md:w-1/2 w-full mt-5 mx-auto">
            <vs-input :label="$t('Family')" v-model="family" name="family" class="w-full" v-validate="'required|alpha_spaces|min:3|max:50'" :readonly="status=='pending'|| status=='confirm'  ? true : false"
                      :success="status=='confirm' ? true : false" :warning="status=='pending' ? true : false"
                      val-icon-success="icon-check" val-icon-warning="icon-clock" val-icon-pack="feather"/>
            <span class="text-danger text-sm" v-show="errors.has('BaseData.family') && this.BaseDataSubmit">{{ errors.first('BaseData.family') }}</span>
          </div>

          <div class="vx-col md:w-1/2 w-full mt-5 mx-auto">
            <vs-input :label="$t('Date birth')" :descriptionText="$t('18 years and older can authenticate!')" v-model="dateBirth" id="dateBirth" name="dateBirth" class="w-full vazir"
                      :class="$vs.rtl ? 'rtl' : 'ltr'" v-validate="'required'"
                      :success="status=='confirm' ? true : false" :warning="status=='pending' ? true : false" @focus="showDatePicker = true"
                      val-icon-success="icon-check" val-icon-warning="icon-clock" val-icon-pack="feather" :readonly="status=='pending'|| status=='confirm'  ? true : false"/>
            <span class="text-danger text-sm" v-show="errors.has('BaseData.dateBirth') && this.BaseDataSubmit">{{ errors.first('BaseData.dateBirth') }}</span>
          </div>
          <date-picker v-model="dateBirth" view="year" :show="showDatePicker" @close="showDatePicker=false" :auto-submit="true" color="rgba(var(--vs-primary), 1)"
                      :locale="islocale" :max="maxDate" :locale-config="localeConfig"
                       :format="(islocale=='fa')?'jYYYY/jMM/jDD' : 'YYYY-MM-DD'" element="dateBirth">
          </date-picker>


          <transition>
            <div class="vx-col md:w-1/2 w-full mt-5 mx-auto" v-if="iranian">
              <vs-input :label="$t('National ID')" v-model="nationalCode" name="nationalCode" class="w-full vazir" :class="$vs.rtl ? 'rtl' : 'ltr'" maxlength="10" v-validate="'required|numeric|min:10|max:10'"
                        :success="status=='confirm' ? true : false" :warning="status=='pending' ? true : false"
                        val-icon-success="icon-check" val-icon-warning="icon-clock" val-icon-pack="feather" :readonly="status=='pending'|| status=='confirm'  ? true : false"/>
              <span class="text-danger text-sm" v-show="errors.has('BaseData.nationalCode') && this.BaseDataSubmit">{{ errors.first('BaseData.nationalCode') }}</span>
            </div>
          </transition>

          <transition>
            <div class="vx-col md:w-1/2 w-full mt-5 mx-auto" v-if="!iranian">
              <vs-input :label="$t('Passport number')" v-model="passportNumber" name="passportNumber" class="w-full" :class="$vs.rtl ? 'rtl' : 'ltr'" maxlength="15" v-validate="'required|max:15'"
                        :success="status=='confirm' ? true : false" :warning="status=='pending' ? true : false"
                        val-icon-success="icon-check" val-icon-warning="icon-clock" val-icon-pack="feather" :readonly="status=='pending'|| status=='confirm'  ? true : false"/>
              <span class="text-danger text-sm" v-show="errors.has('BaseData.passportNumber') && this.BaseDataSubmit">{{ errors.first('BaseData.passportNumber') }}</span>
            </div>
          </transition>


          <div class="vx-col w-full mt-8 mx-auto">
            <p class="mb-1" v-if="iranian">{{$t('Please upload the national card image')}}</p>
            <p class="mb-1" v-else>{{$t('Please upload the passport image')}}</p>
            <div :class="$vs.rtl ? 'rtl' : 'ltr'" dir="ltr">
              <file-pond
                :class="status=='pending'?'warning' : status=='confirm'?'success' : ''"
                name="test"
                ref="pond"
                :disabled="status=='pending'|| status=='confirm'  ? true : false"
                :captureMethod="null"
                :label-idle="$t('Click to upload the file or drag and drop the file')"
                accepted-file-types="image/jpeg, image/png"
                v-bind:server="myServer"
                :files="status=='pending'||status=='confirm' ? myFiles : null"
                :processfile="null"
              />
            </div>
          </div>

          <transition name="slide">
            <div class="w-full flex px-3" v-if="uploadPercentage > 0">
              <p class="mr-3 text-center">{{uploadPercentage}}%</p>
              <vs-progress class="mt-1" :height="12" :percent="uploadPercentage" color="success"></vs-progress>
            </div>
          </transition>

          <div class="vx-col w-full mt-5 mx-auto">
            <vs-button class="ml-auto mt-2 w-full" id="button-submit-base-data" :disabled="btnDisable || status=='pending'||status=='confirm' ? true : false"
                       @click.prevent="BaseDataFormSubmit">{{$t('Submit Information')}}</vs-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<i18n locale="fa">
  {
  "18 years and older can authenticate!":"18 سال به بالا امکان احراز هویت دارند!"
  ,"Please upload the national card image":"لطفا تصویر کارت ملی را آپلود کنید"
  ,"Please upload the passport image":"لطفا تصویر گذرنامه را آپلود کنید"
  ,"National ID is incorrect!":"کد ملی صحیح نیست!"
  ,"Please insert the file!":"لطفا فایل را درج کنید!"
  ,"The information in this section has been successfully verified.":"اطلاعات این بخش با موفقیت تایید شده است."
  ,"Your information is under review and please wait!":"اطلاعات شما در دست بررسی قرار دارد و لطفا منتظر بمانید!"
  ,"The information entered must match the identification document or it will not be verified.":
  "اطلاعات درج شده باید با مدرک شناسایی مطابقت داشته باشد و در غیر این صورت تایید نمیگردد."

  ,"The time it takes to upload your images varies according to the size of the images and may take some time, please wait until the upload is complete.":
  "مدت زمان آپلود تصاویر شما به نسبت حجم تصاویر متغییر است و ممکن است مدتی زمان ببرد، لطفا شکیبا باشید."

  ,"If the image quality is poor, it may not be approved and you may re-upload.":
  "اگر کیفیت تصویر نامناسب باشد ممکن است تایید نشود و مجدد آپلود نمایید."
  }
</i18n>

<script>
  import MobileVerify from './MobileVerify'
  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
  import axios from "../../../http/axios";
  import jalaliMmoment from "jalali-moment";


  // Import Vue FilePond
  import vueFilePond from 'vue-filepond'

  // Import FilePond styles
  import 'filepond/dist/filepond.min.css'
  // Import image preview plugin styles
  import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

  // Import image preview and file type validation plugins
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

  // Create component
  const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
  )


  export default {
    props: {
      dataUser: {
        required: true,
      }
    },
    name: 'BaseData',
    data () {
      return {
        iranian: true,
        name: '',
        family: '',
        nationalCode: '',
        passportNumber: '',
        dateBirth:'',
        myFiles: [
          {
            source:
              "authentication/identification/image.jpg",
            options: {
              type: "local"
            }
          }
        ],
        maxDate: null,
        showDatePicker: false,
        localeConfig:{
          fa: {
            dow: 6,     //  first day of week
            dir: 'rtl',
            displayFormat: 'jYYYY/jMM/jDD'
          },
          en: {
            dow: 0,
            dir: 'ltr',
            displayFormat: 'YYYY-MM-DD'
          }
        },
        BaseDataSubmit: false,
        status: null,
        uploadPercentage: 0,
        btnDisable: false,
        myServer: {
          process: null,
          load: (source, load) => {
            axios.get(source, {responseType: 'blob' })
              .then((response) => {
                const new_blob = new Blob( [ response.data ], { type: 'image/jpg' } );
                load(new_blob)
              })
            /*
            const object ={
              headers: {
                'Authorization': 'Bearer '+ localStorage.getItem('accessToken'),
              },
            }
            fetch(source,object).then(res => res.blob()).then(load);
             */
          }
        },
      }
    },
    created () {

      //OldYear18
      const NowDate = jalaliMmoment()
      if (this.islocale == 'fa') this.maxDate = NowDate.subtract(18, 'jYear').format('jYYYY/jMM/jDD')
      else this.maxDate = NowDate.subtract(18, 'jYear').format('YYYY/MM/DD')


      if(this.dataUser.identification && this.dataUser.identification.status){
        this.status = this.dataUser.identification.status;
        this.name = this.dataUser.name
        this.family = this.dataUser.family
        this.dateBirth = this.dataUser.date_birth
        if(this.dataUser.identification.iranian == "true"){
          this.iranian = true;
          this.nationalCode = this.dataUser.national_code
        }else{
          this.iranian = false;
          this.passportNumber = this.dataUser.national_code
        }
      }
    },
    watch:{
      nationalCode (value) {
        value = this.parseNumberArabic(value)
        this.nationalCode = value.replace(/[^\d]/g, '')
      },
      dateBirth(value){
        if(value.length!=10)
          this.showDatePicker = true,this.dateBirth='';
      }
    },
    methods: {
      BaseDataFormSubmit () {
        this.$validator.validateAll('BaseData').then(result => {
          if (result) {
            if (this.checkNationalCode() || !this.iranian) {

              if(!this.$refs.pond.getFiles()[0]){
                this.$swal(this.$t('Warning'), this.$t('Please insert the file!'),'warning')
                return;
              }

              this.$vs.loading({
                background: this.backgroundLoading,
                color: this.colorLoading,
                container: '#button-submit-base-data',
                scale: 0.65
              })
              this.btnDisable = true;

              //const file = this.$refs.pond.getFiles();
              const bodyFormData = new FormData()
              bodyFormData.append('iranian', this.iranian)
              bodyFormData.append('name', this.name)
              bodyFormData.append('family', this.family)
              bodyFormData.append('nationalCode',this.nationalCode)
              bodyFormData.append('passportNumber',this.passportNumber)
              bodyFormData.append('dateBirth',this.dateBirth)
              bodyFormData.append('file', this.$refs.pond.getFiles()[0].file);

              const self = this
              axios.post('/authentication/base-data', bodyFormData,{
                onUploadProgress: function( progressEvent ) {
                  this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                }.bind(this)
              })
              .then(function (response) {
                if (response.data.status == true) {
                  self.$swal({
                    icon: 'success',
                    title: self.$t('Success'),
                    text: response.data.msg
                  }).then(() => {
                    self.$emit('getData')
                    self.status = 'pending'
                  })

                } else {
                  self.$vs.notify({title: self.$t('Error'), text: response.data.msg, iconPack: 'feather', icon: 'icon-alert-circle', color: 'danger'})
                }
                self.btnDisable = false
                self.uploadPercentage = 0
                self.$vs.loading.close('#button-submit-base-data > .con-vs-loading')
              })
              .catch(function (error) {
                console.log(error)
                self.uploadPercentage = 0
                self.$vs.loading.close('#button-submit-base-data > .con-vs-loading')
              })

            } else {
              this.$swal(this.$t('Warning'), this.$t('National ID is incorrect!'),'warning')
            }
          } else {
            this.BaseDataSubmit = true
          }
        })
      },
      checkNationalCode () {
        let code = this.nationalCode

        const allEqual = code.split('').every(char => char === code[0])
        if (allEqual) return false

        const L = code.length
        if (L < 8 || parseInt(code, 10) == 0) return false
        code = (`0000${code}`).substr(L + 4 - 10)
        if (parseInt(code.substr(3, 6), 10) == 0) return false
        const c = parseInt(code.substr(9, 1), 10)
        let s = 0
        for (let i = 0; i < 9; i++) s += parseInt(code.substr(i, 1), 10) * (10 - i)
        s = s % 11
        return (s < 2 && c == s) || (s >= 2 && c == (11 - s))
        return true

      },

    },
    components:{
      MobileVerify,
      datePicker: VuePersianDatetimePicker,
      FilePond
    }
  }
</script>

<style lang="scss">
  #BaseData{
    button.active .vs-button-linex{
      width: 100%;
    }


    .rtl .filepond--wrapper div{
      direction: rtl;
      text-align: right;
    }
    .rtl .filepond--wrapper .filepond--file-info{
      margin: 0em;
    }

    .rtl .filepond--file .filepond--file-status{
      margin-right: auto;
      margin-left: 2.25em !important;
    }

    .filepond--file-info,.filepond--file-status{
      font-size: 18px !important;
    }
    .filepond--credits{
      display: none;
    }

    .filepond--file-action-button,.filepond--drop-label, .filepond--drop-label label{
      cursor: pointer;
    }

    /* the text color of the drop label*/
    .filepond--drop-label {
      color: #555;
      font-family: iranyekan,"Montserrat", Helvetica, Arial, sans-serif;
    }

    /* underline color for "Browse" button */
    .filepond--label-action {
      text-decoration-color: #aaa;
    }

    /* the background color of the filepond drop area */
    .filepond--panel-root {
      background-color: #eee;
    }

    /* the border radius of the drop area */
    .filepond--panel-root {
      border-radius: 0.5em;
    }

    /* the border radius of the file item */
    .filepond--item-panel {
      border-radius: 0.5em;
    }

    /* the background color of the file and file panel (used when dropping an image) */
    .filepond--item-panel {
      background-color: #555;
    }

    /* the background color of the drop circle */
    .filepond--drip-blob {
      background-color: #999;
    }

    /* the background color of the black action buttons */
    .filepond--file-action-button {
      background-color: rgba(0, 0, 0, 0.5);
    }

    /* the icon color of the black action buttons */
    .filepond--file-action-button {
      color: white;
    }

    /* the color of the focus ring */
    .filepond--file-action-button:hover,
    .filepond--file-action-button:focus {
      box-shadow: 0 0 0 0.125em rgba(255, 255, 255, 0.9);
    }

    /* the text color of the file status and info labels */
    .filepond--file {
      color: white;
    }

    /* error state color */
    [data-filepond-item-state*='error'] .filepond--item-panel,
    [data-filepond-item-state*='invalid'] .filepond--item-panel {
      //background-color: red;
    }

    [data-filepond-item-state='processing-complete'] .filepond--item-panel {
      background-color: green;
    }

    /* bordered drop area */
    .filepond--panel-root {
      background-color: transparent;
      border: 2px solid #2c3340;
    }

    .filepond--file-status-sub,.filepond--file-info-sub{
      opacity: 0.8 !important;
    }

    .success .filepond--panel-root{
      border-color: rgba(var(--vs-success), 1) !important;
    }
    .warning .filepond--panel-root{
      border-color: rgba(var(--vs-warning), 1) !important;
    }

  }
</style>
